import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import ReactToPrint from "react-to-print";
import formatData from "@mnjsplatform/data/lib/utils/formatData";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import {ScreenFormatContext} from "@mnjsplatform/data";
import i18next from "i18next";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import {WorkplaceTypes} from "../Common/constants";

class PaySlip extends Component {
    constructor(props, context) {
        super(props, context);

        //this.headerValues = ["FioTn", "AsCodeName", "SumPNDbt", "SumPNVal", "BegSaldo", "EndSaldo"];
        this.footerValues = ["AllDbtSum", "AllCrdSum", "Cash", "Card", "Bank"];
        this.moneyValues = ["SumPNDbt", "SumPNVal", "BegSaldo", "EndSaldo", "AllDbtSum", "AllCrdSum", "Cash", "Card", "Bank", "DbtSum", "CrdSum"];

        this.refForPrint = React.createRef();
    }

    componentDidMount() {
        this.initialize();
    }

    componentWillUnmount() {
        this.allowSelectElements(true);
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.lckPrintPayListHdr.reset());
            await this.props.dispatch(this.props.lckPrintPayListTab.reset());

            this.allowSelectElements(false);
            await this.props.dispatch(this.props.lckPrintPayListHdr.initialize({}, {withParams: true, newItem: true}));
            await this.props.dispatch(this.props.lckPrintPayListTab.initialize({}, {withParams: false, newItem: true}));
            await this.refreshTable();
        } catch (e) {
            console.error(e);
        }
    }

    refreshTable = async() => {
        try {
            await this.props.dispatch(this.props.lckPrintPayListTab.applyParams(this.props.lckPrintPayListHdrParams));
        } catch (e) {
            console.error(e);
        }
    };

    allowSelectElements = (allow) => {
        let value = undefined;
        if (!allow) {
            value = () => false;
        }
        document.ondragstart = value;
        document.onselectstart = value;
        document.oncontextmenu = value;
    };

    get MonthName(){
        let reportMonthText = "";
        let row = this.props.lckPrintPayListHdrParams.getRow(0);
        if (row && row.DateEnd) {
            reportMonthText = formatData(this.props.lckPrintPayListHdrParams.getFieldInfo("DateEnd"), row.DateEnd);
        }
        return reportMonthText;
    }

    getMoneyValue = (value) => value ? value.toFixed(2) : null;

    renderParamRowValues = (label, value) => {
        return (
            <>
                <div className="row">
                    <div className="col-md-4 field-title">
                        {label}
                    </div>
                    <div className="col-md-8">
                        {value}
                    </div>
                </div>
                <hr className="m-1"/>
            </>
        );
    };

    renderParamRow = (h, fn) => {
        let value = this.moneyValues.some(v => v === fn) ? this.getMoneyValue(h.row[fn]) : h.ed(fn);
        return this.renderParamRowValues(h.lbl(fn), value);
    };

    renderPaySlipHeader = (h) => {
        return (
            <>
                {this.renderParamRowValues(i18next.t("BillingMonth"), this.MonthName)}
                {this.props.headerValues.map(fn => <React.Fragment key={fn}>
                    {this.renderParamRow(h, fn)}
                </React.Fragment>)}
            </>
        );
    };

    renderPaySlipFooter = (h, isDesktop) => {
        return (
            <>
                {this.footerValues.map(fn => {
                    if (!isDesktop && !h.row[fn])
                        return null;

                    return (
                        <React.Fragment key={fn}>
                            {this.renderParamRow(h, fn)}
                        </React.Fragment>
                    );
                })}
            </>
        );
    };

    gridRenderCellEx = (cellParams) => {
        if (this.moneyValues.some(v => v === cellParams.fieldInfo.Name)) {
            return this.getMoneyValue(cellParams.row[cellParams.fieldInfo.Name]);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    };

    renderGridMobileView = () => {
        let dataTable = this.props.lckPrintPayListTab.dataTable();

        let getRowKey = (r, postfix = "1") => {
            let key = this.props.lckPrintPayListTab.getRowKey(r);
            let result = "";
            for (let f in key) {
                result += "_" + key[f];
            }

            return result + "_" + postfix;
        };

        return (
            <>
                {
                    dataTable.filter(r => r.DbtCode)
                        .map(r => {
                            let key = getRowKey(r, "1");
                            return (
                                <div className="paySlip_mobile_moneyItem" key={key}>
                                    <PlaceholderWrapper placeholderId={key}
                                                        canCollapse={true}
                                                        showInstruction={false}
                                                        showSplitterLine={false}
                                                        title={i18next.t("PaySlip_Accrual", {code: r.DbtCode, name: r.DbtName})}
                                    >
                                        {this.renderParamRowValues(i18next.t("PaySlip_WorkedTime"), r.DbtDayTime)}
                                        {this.renderParamRowValues(i18next.t("Total"), this.getMoneyValue(r.DbtSum))}
                                    </PlaceholderWrapper>
                                </div>
                            );
                        })
                }

                {
                    dataTable.filter(r => r.CrdCode)
                        .map(r => {
                            let key = getRowKey(r, "2");
                            return (
                                <div className="paySlip_mobile_moneyItem" key={key}>
                                    <PlaceholderWrapper placeholderId={key}
                                                        canCollapse={true}
                                                        showInstruction={false}
                                                        showSplitterLine={false}
                                                        title={i18next.t("PaySlip_Retention", {code: r.CrdCode, name: r.CrdName})}
                                    >
                                        {this.renderParamRowValues(i18next.t("Total"), this.getMoneyValue(r.CrdSum))}
                                    </PlaceholderWrapper>
                                </div>
                            );
                        })
                }
            </>
        );
    };

    renderGridData = (isDesktop) => {
        if (isDesktop) {
            return (
                <GridView dataItem={this.props.lckPrintPayListTab}
                          readOnly={true}
                          renderCellEx={this.gridRenderCellEx}
                />
            );
        }

        return this.renderGridMobileView();
    };

    renderFooterData = (isDesktop) => {
        return (
            <>
                {isDesktop && <hr className="m-1"/>}

                <ComplexParam dataItem={this.props.lckPrintPayListHdr}
                              rowIndex={0}
                              readOnly={true}
                              renderParams={(h) => this.renderPaySlipFooter(h, isDesktop)}
                />
            </>
        );
    };

    renderParamset = (h, fn) => {
        return (<div className="row">
            <div className="col-md-9">
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-6 field-title">
                                {h.lbl(fn)}
                            </div>
                            <div className="col-md-3">
                                {h.ed(fn)}
                            </div>
                        </div>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }
    render() {
        if (!this.props.lckPrintPayListHdr.isInitialized || !this.props.lckPrintPayListTab.isInitialized
            || this.props.lckPrintPayListHdr.isError || this.props.lckPrintPayListTab.isError
        ) {
            return null;
        }

        return (
            <ScreenFormatContext.Consumer>
                {isDesktop => {
                    return (
                        <div id="paySlipReportHolder">
                            {/*<PlaceholderWrapper placeholderId="10"
                                                title={<><i className='fa fa-info'/>{i18next.t('PaySlipFormation')}</>}
                                                canCollapse={false}>
                                <PlaceholderWrapper placeholderId="11" showHeaderTitle={false} showSplitterLine={false}>
                                    {renderHTML(i18next.t("PaySlipFormation_Instruction1"))}
                                </PlaceholderWrapper>
                                {(i18next.t("PaySlipFormation_Instruction2") ? <PlaceholderWrapper placeholderId="12" showHeaderTitle={false} showSplitterLine={false}>{renderHTML(i18next.t("PaySlipFormation_Instruction2"))}</PlaceholderWrapper> : null)}
                            </PlaceholderWrapper>*/}
                            <PlaceholderWrapper placeholderId="20"
                                                title={<><i className="fa fa-file-text-o"></i> {i18next.t('PaySlip')}</>}
                                                canCollapse={false}>
                                <ComplexParam dataItem={this.props.lckPrintPayListHdrParams}
                                              readOnly={false}
                                              showSearchBar={false}
                                              showApplyButton={false}
                                              autoApplyParams={true}
                                              rootPath="/"
                                              parentDataItem={this.props.lckPrintPayListHdr}
                                              renderParams={this.renderParamset}
                                              afterApplyParams={this.refreshTable}
                                />
                                <ReactToPrint
                                    trigger={() => <button type="button" className="btn btn-regular -goahead">{i18next.t("Print")}</button>}
                                    content={() => this.refForPrint.current}
                                />

                                {/*для печати*/}
                                <div style={{display: (this.props.appParams.workplaceType === WorkplaceTypes.Baltika ? 'none' : '')}}>
                                    {this.props.paySlipForm(
                                        {
                                            headerDataItem: this.props.lckPrintPayListHdr,
                                            tableDataItem: this.props.lckPrintPayListTab,
                                            monthName: this.MonthName,
                                            ref: this.refForPrint
                                        })
                                    }
                                </div>

                                {
                                    this.props.appParams.workplaceType === WorkplaceTypes.Baltika &&
                                    <ComplexParam dataItem={this.props.lckPrintPayListHdr}
                                                  rowIndex={0}
                                                  readOnly={true}
                                                  renderParams={this.renderPaySlipHeader}
                                    />
                                }

                                {this.props.appParams.workplaceType === WorkplaceTypes.Baltika && !isDesktop && this.renderFooterData(isDesktop)}
                                {this.props.appParams.workplaceType === WorkplaceTypes.Baltika && this.renderGridData(isDesktop)}
                                {this.props.appParams.workplaceType === WorkplaceTypes.Baltika && isDesktop && this.renderFooterData(isDesktop)}
                            </PlaceholderWrapper>
                        </div>
                    );
                }}
            </ScreenFormatContext.Consumer>
        );
    }
}

PaySlip.propTypes = {
    dispatch: PropTypes.func.isRequired,
    lckPrintPayListHdr: PropTypes.object,
    lckPrintPayListHdrParams: PropTypes.object,
    lckPrintPayListTab: PropTypes.object,
    appParams: PropTypes.object,
    paySlipForm: PropTypes.func,
    headerValues: PropTypes.array
}

PaySlip.defaultProps = {
    headerValues: ["FioTn", "AsCodeName", "SumPNDbt", "SumPNVal", "BegSaldo", "EndSaldo"],
};

function mapStateToProps(state, ownProps) {
    return {
    }
}

export default connect(mapStateToProps)(PaySlip);